module.exports = __webpack_public_path__ + "static/media/accountScreen.b4b02ff5.png";